import { PipeTransform, Pipe } from "@angular/core";

@Pipe({ name: "companyFederalNumber" })
export class CompanyFederalNumberFormatPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return "";
    }
    const cleaned = value.replace(/[^a-zA-Z0-9]/g, "");
    return cleaned.replace(/(\w{2})(\w{3})(\w{3})(\w{4})(\w{2})/, "$1.$2.$3/$4-$5");
  }
}
